<script setup>
import { ref, computed, getCurrentInstance } from 'vue';

// Component Imports
import Form from '../../common/form/Form';
import FormSaveBtn from '../../common/form/FormSaveBtn';

// Props & Emits
const props = defineProps({
    modal: Object,
    options: Object,
});

const emit = defineEmits(['hide-modal']);

// Store Access
const { proxy } = getCurrentInstance();
const store = proxy.$store;

// State
const formId = ref('');
const tableName = 'odp_credit_log';
const id = 0;
const customerFormId = props.options.customerFormId;

// Computed
const customerId = computed(() => {
    return store.state[customerFormId].id;
});

// Methods
const createForm = () => {
    formId.value = 'form:' + tableName + ':' + id;

    // Assigning the form ID to the modal object triggers the unsaved confirmation modal
    props.modal.formId = formId.value;

    store.dispatch('forms/createForm', {
        tableName: tableName,
        id: id,
        fieldNames: [
            'amount',
        ],
        currentData: {
            debited: 1,
            customerId: customerId.value,
        },
        onSave: (obj) => {
            const amount = obj.amount;

            // Saves the booking's new amountPaid value and updates the form.
            store.dispatch('itemData/get', {
                    tableName: 'm_registrants_registrants',
                    id: customerId.value
                })
                .then((res) => {
                    let creditAmount = res.creditAmount || 0;
                    creditAmount = parseFloat(creditAmount) - parseFloat(amount);
                    creditAmount = creditAmount.toFixed(2);

                    // Update the active form to show the new value
                    store.commit(customerFormId + '/presetData', {
                        name: 'creditAmount',
                        value: creditAmount
                    });

                    // Save the booking's new amountPaid
                    return store.dispatch('itemData/update', {
                        tableName: 'm_registrants_registrants',
                        id: customerId.value,
                        data: {
                            creditAmount: creditAmount
                        }
                    });
                })
                .then(() => {
                    emit('hide-modal');
                });
        },
    });
};

// Initial Logic (Equivalent to created lifecycle)
createForm();
</script>

<template>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Delete credit</h4>
                <button
                    type="button"
                    class="btn-close"
                    @click="emit('hide-modal')"
                    aria-label="Close"
                ></button>
            </div>

            <div class="modal-body">
                <Form v-if="formId" :form-id="formId"/>

                <footer class="text-center mt-3">
                    <FormSaveBtn
                        :button-text="'Save'"
                        :cancel-on-save="true"
                        :form-id="formId"
                    />
                </footer>
            </div>
        </div>
    </div>
</template>